// Pure helpers for the custom audio player controls.
// Kept free of React/scss imports so they're trivially unit-testable.

/**
 * Format a number of seconds as `m:ss`.
 * Guards `NaN`/`Infinity`/negative (e.g. duration before metadata loads).
 */
export function formatAudioTime(seconds: number): string {
  const safe = Number.isFinite(seconds) && seconds > 0 ? Math.floor(seconds) : 0
  const m = Math.floor(safe / 60)
  const s = safe % 60
  return `${m}:${s < 10 ? '0' : ''}${s}`
}

const PLAYBACK_RATES = [1, 1.5, 2] as const

/**
 * Cycle the playback rate 1× → 1.5× → 2× → 1×.
 * An unknown rate falls back to 1×.
 */
export function nextPlaybackRate(rate: number): number {
  const i = PLAYBACK_RATES.indexOf(rate as (typeof PLAYBACK_RATES)[number])
  return PLAYBACK_RATES[(i + 1) % PLAYBACK_RATES.length] ?? 1
}
